<template>
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M12 3.5L14.82 9.2L21 10.1L16.5 14.48L17.64 20.5L12 17.42L6.36 20.5L7.5 14.48L3 10.1L9.18 9.2L12 3.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      vector-effect="non-scaling-stroke"
    />
  </svg>
</template>
